export default {
      id: "color_fish-usage",
      viewBox: "0 0 144.8 102.4",
      url: __webpack_public_path__ + "sprite.svg#color_fish",
      toString: function () {
        return this.url;
      }
    }